import React from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  makeStyles,
  Modal,
  Snackbar,
  Typography,
} from "@material-ui/core";
import { Close, ErrorOutline } from "@material-ui/icons";
import { gpColors } from "../../constants/colors";
const useStyles = makeStyles((theme) => ({
  deleteButton: {
    // textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
  },
  modalCard: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 370,
    // height: 400,
    backgroundColor: "#fff",
    border: "1px",
    borderRadius: "15px",
    textAlign: "center",
  },
}));

function ProductDetailModal(props) {
  const classes = useStyles();

  return (
    <div>
      {/* confirmation modal */}
      <Modal open={props.confirmModal}>
        <Card className={classes.modalCard}>
          <Box sx={{ color: "#CA0B00", margin: 2 }}>
            <ErrorOutline style={{ fontSize: "70px" }} />
          </Box>
          <Typography style={{ margin: 3 }}>
            Are you sure you want to delete this item?
          </Typography>
          <Box>
            <Button
              variant="outlined"
              onClick={() => props.closeConfirmModal("CANCEL")}
            >
              Cancel
            </Button>
            <Button
              className={classes.deleteButton}
              style={{ margin: "10px" }}
              onClick={() => props.closeConfirmModal("DELETE")}
            >
              Delete
            </Button>
          </Box>
        </Card>
      </Modal>

      {/* sucess alert for data successfully saved to DB */}
      <Snackbar
        ContentProps={{
          style: { background: "green" },
        }}
        open={props.successAlert}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => {
          props.handleAlertClose();
        }}
        message="Product has been deleted successfully!!"
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => props.handleAlertClose()}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      />
    </div>
  );
}

export default ProductDetailModal;
